import type { ConditionOutcome, ProjectedWorkflow } from "../../../../api/threads/liveMessages";

export type DeclaredOutcomeState = "satisfied" | "unsatisfied" | "undetermined";

export interface OutcomeView {
  readonly state: DeclaredOutcomeState;
  /** The entry that shows it: a missed condition's evidence, else the latest one. */
  readonly evidenceEntry: number | null;
  readonly conditions: readonly ConditionOutcome[];
}

/**
 * The run's outcome as the server evaluated it against the Workflow's declaration (W-22);
 * `null` when the Workflow declares none, so the run shows its completion only, and while it
 * is still open on a run that goes on, which says nothing yet. A decided outcome shows whatever
 * the run's state: a scrapped change set decides it with later steps never due.
 */
export function outcomeView(workflow: ProjectedWorkflow): OutcomeView | null {
  const outcome = workflow.outcome;
  if (outcome === undefined || outcome.state === "not_declared") return null;
  if (outcome.state === "undetermined" && workflow.active && !workflow.completed) return null;
  const conditions = outcome.conditions ?? [];
  const shown = conditions.filter((condition) => condition.state === outcome.state).flatMap((condition) => (condition.evidence_entry == null ? [] : [condition.evidence_entry]));
  const evidenceEntry = shown.length === 0 ? null : outcome.state === "satisfied" ? Math.max(...shown) : (shown[0] ?? null);
  return { state: outcome.state, evidenceEntry, conditions };
}
